var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tenant && _vm.tenant.id)?_c('TenantReadinessCheck',{ref:"check",attrs:{"tenant-id":_vm.tenant.id}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }